<template>
  <b-card class="top-priorities text-center">
    <h6><strong>Top priorities this week</strong></h6>
    <div class="pt-4">
      <priorities v-if="!isLoading" :me="me" :priorities="computedPriorities" />
      <div v-else class="text-center">
        <b-spinner variant="primary" label="Loading..." />
      </div>
    </div>
    <template #footer>
      <div v-if="me" class="mt-1">
        <b-button variant="link" @click.prevent="$refs.edit.show()">
          Edit priorities
        </b-button>
      </div>
    </template>
    <b-modal ref="edit" hide-footer size="lg" title="Edit my top priorities this week">
      <edit-priorities
        :priorities="prioritiesMe"
        :toggle-item="togglePriority"
        :delete-item="deletePriority"
      >
        <template #update="{ priority, close }">
          <edit-priority-form
            edit
            :content="priority.content"
            :submitting="submitting"
            :state="state"
            @submit="updatePriority(priority, $event, { close })"
            @cancel="close()"
          />
        </template>
        <template #add="{ close }">
          <edit-priority-form
            :submitting="submitting"
            :state="state"
            @submit="addPriority($event, { close })"
            @cancel="close()"
          />
        </template>
      </edit-priorities>
    </b-modal>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { TopPriorities as Priorities, EditPriorities } from '@/components/Priorities'
import EditPriorityForm from '@/components/forms/EditPriorityForm.vue'
import statuses from '@/helpers/statuses'

export default {
  name: 'TopPriorities',

  props: {
    me: {
      type: Boolean,
      default: false
    },

    userId: {
      type: Number
    }
  },

  watch: {
    userId() {
      this.fetchPriorities()
    }
  },

  data() {
    return {
      submitting: false,
      state: {}
    }
  },

  computed: {
    ...mapGetters([
      'priorities',
      'prioritiesMe',
      'loadingPrioritiesMe',
      'loadingPriorities'
    ]),

    computedPriorities() {
      return ((this.me ? this.prioritiesMe : this.priorities(this.userId)) || []).filter(p => !p.isDone)
    },

    isLoading() {
      return (this.me ? this.loadingPrioritiesMe : this.loadingPriorities(this.userId)) === statuses.LOADING
    }
  },

  mounted() {
    this.fetchPriorities()
  },

  methods: {
    async fetchPriorities() {
      if (this.me) {
        await this.$store.dispatch('fetchPrioritiesMe')
      } else {
        await this.$store.dispatch('fetchPriorities', this.userId)
      }
    },

    addPriority(data, { close }) {
      this.submitting = true
      this.$store.dispatch('addPriority', data)
        .then(() => close())
        .catch(errors => { this.state = errors })
        .finally(() => (this.submitting = false))
    },

    updatePriority({ id }, data, { close }) {
      this.submitting = true
      this.$store.dispatch('updatePriority', { id, data })
        .then(() => close())
        .catch(errors => { this.state = errors })
        .finally(() => (this.submitting = false))
    },

    async togglePriority(id) {
      await this.$store.dispatch('togglePriority', id)
    },

    async deletePriority(id) {
      await this.$store.dispatch('deletePriority', id)
    }
  },

  components: {
    Priorities,
    EditPriorities,
    EditPriorityForm
  }
}
</script>
